import React, { useState, useEffect } from "react";
import icon from "../../Assets/icon.png";
import "../login.css";
import { Link, useNavigate } from "react-router-dom";
import { FaCheck } from "react-icons/fa";
import Modal from "react-bootstrap/Modal";
import "./tender.css";
import axios from "axios";
import PaymentService from "../../Services/payment.service";
import Table from "react-bootstrap/Table";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import ProjectSidebar from "./ProjectSidebar";

function TenderPayment() {
  const navigate = useNavigate();
  const today = new Date();
  const month = today.getMonth() + 1;
  const year = today.getFullYear();
  const date = today.getDate();
  const currentDate = `${date}-${month}-${year}`;

  const [details, setDetails] = useState({
    email: "",
    name: "",
    companyName: "",
    mobileNum: "",
    category: "",
  });
  const [finalAmt, setFinalAmt] = useState(0);
  const [otp, setOtp] = useState("");
  const [openOtpModal, setOpenOtpModal] = useState(false);
  const [userDetails, setUserDetails] = useState({});
  const [stepOneDeets, setStepOneDeets] = useState({});
  const [charges, setCharges] = useState(0);
  const [isCustomCharge, setIsCustomCharge] = useState(false);
  const applicantEmail = localStorage.getItem("aplntEml");
  const savedTimeStamp = localStorage.getItem("tsmtmp");
  const [isVerified, setIsVerified] = useState(
    localStorage.getItem("aplntEml") != null ? true : false
  );

  useEffect(() => {
    if (savedTimeStamp) {
      const now = Date.now();
      const fiveHours = 1 * 60 * 60 * 1000;
      const timeElapsed = now - parseInt(savedTimeStamp, 10);

      if (timeElapsed > fiveHours) {
        localStorage.removeItem("userDeets");
        localStorage.removeItem("aplntEml");
        setIsVerified(false);
      } else {
        if (applicantEmail) {
          setDetails({ ...details, email: applicantEmail.email });
        }
      }
    }
  }, []);

  const handleChange = (e) => {
    const isNumberRegex = /^[0-9.]*$/;
    const { name, value } = e.target;

    if (name === "mobileNum") {
      if (!isNumberRegex.test(e.target.value)) {
        return;
      }
    }

    if (name === "category") {
      if (value === "Document Charges") {
        setIsCustomCharge(false);
        const x = `Rs. ${2950}/- (incl. GST)`;
        setFinalAmt(x);
        setCharges(2950);
      } else if (value === "Processing Fees") {
        setIsCustomCharge(false);
        const x = `Rs. ${29500}/- (incl. GST)`;
        setFinalAmt(x);
        setCharges(29500);
      } else if (value === "Earnest Money Deposit") {
        setIsCustomCharge(false);
        const x = `Rs. ${250000}/- (no GST)`;
        setFinalAmt(x);
        setCharges(250000);
        setIsCustomCharge(false);
      } else {
        setIsCustomCharge(true);
        setFinalAmt("");
        setCharges(0);
      }
    }
    setDetails({ ...details, [name]: value });
  };

  const handleCustomCharges = (e) => {
    const isNumberRegex = /^[0-9.]*$/;

    if (!isNumberRegex.test(e.target.value)) {
      return;
    }

    setFinalAmt(e.target.value);
    setCharges(e.target.value);
  };

  const handleGetOtp = (e) => {
    e.preventDefault();

    setOpenOtpModal(true);

    const req = {
      EmailId: details.email,
    };

    if (details.email != "") {
      PaymentService.verifyEmail(req)
        .then((response) => {})
        .catch((e) => console.log(e));
    } else {
      alert("Enter Email ID");
      return;
    }
  };

  const handleOtpChange = (e) => {
    setOtp(e.target.value);
  };

  const cuurentTime = Date.now();

  const submitOtp = () => {
    const req = {
      Otpinfo: otp,
      Emailinfo: details.email,
    };

    PaymentService.verifyOtp(req)
      .then((response) => {
        if (response.data) {
          setOpenOtpModal(false);
          setIsVerified(true);
          setUserDetails(response.data);
          localStorage.setItem("userDeets", JSON.stringify(response.data));
          localStorage.setItem("tsmtmp", cuurentTime.toString());
          localStorage.setItem("aplntEml", response.data.email);
        }
      })
      .catch((e) => console.log(e));
  };

  const handleGetOrderId = (e) => {
    e.preventDefault();

    const user = JSON.parse(localStorage.getItem("userDeets"));

    if (details.mobileNum.length < 10) {
      alert("Please Enter Valid Phone Number!");
      return;
    }

    const req = {
      amount: charges * 100,
      currency: "INR",
      receipt: user.receiptnumber,
      name: details.name,
      email: applicantEmail,
      phone: details.mobileNum,
      company_name: details.companyName,
      catrgory: details.category,
    };

    PaymentService.getOrderId(req)
      .then((response) => {
        if (response.data) {
          setStepOneDeets(response.data);
          sendOrderId(response.data);
        }
      })
      .catch((e) => console.log(e));
  };

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, [handleGetOrderId]);

  const [paymentDetails, setPaymentDetails] = useState({
    razorpay_payment_id: "",
    razorpay_order_id: "",
    razorpay_signature: "",
  });
  const [paymentErr, setPaymentErr] = useState({});

  const [paymentStatus, setPaymentStatus] = useState("");

  const sendOrderId = (data) => {
    var options = {
      key: "rzp_live_cmEOsymfFPeQM8", // Enter the Key ID generated from the Dashboard
      amount: data.amount, // Amount is in currency subunits. Default currency is INR. Hence, 50000 refers to 50000 paise
      currency: "INR",
      name: details.companyName, //your business name
      description: "Live Transaction",
      image: "https://icorp.global/static/media/icon.15b9fa02d155cee99d00.png",
      order_id: data.id, //This is a sample Order ID. Pass the `id` obtained in the response of Step 1
      handler: function (response) {
        setPaymentDetails({
          razorpay_payment_id: response.razorpay_payment_id,
          razorpay_order_id: response.razorpay_order_id,
          razorpay_signature: response.razorpay_signature,
        });
        setPaymentStatus("Success");
        alert(response.razorpay_payment_id);
        alert(response.razorpay_order_id);
        alert(response.razorpay_signature);
      },
      prefill: {
        //We recommend using the prefill parameter to auto-fill customer's contact information, especially their phone number
        name: details.name, //your customer's name
        email: details.email,
        contact: details.mobileNum, //Provide the customer's phone number for better conversion rates
      },
      notes: {
        address: "Razorpay Corporate Office",
      },
      theme: {
        color: "#3399cc",
      },
    };

    var rzp1 = new window.Razorpay(options);
    rzp1.on("payment.failed", function (response) {
      setPaymentErr(response.error);
      setPaymentStatus("Failure");
      //   alert(response.error.code);
      //   alert(response.error.description);
      //   alert(response.error.source);
      //   alert(response.error.step);
      //   alert(response.error.reason);
      //   alert(response.error.metadata.order_id);
      //   alert(response.error.metadata.payment_id);
    });

    rzp1.open();
  };

  const [openModal, setOpenModal] = useState(false);

  useEffect(() => {
    checkSignature();
  }, [paymentStatus]);

  const checkSignature = () => {
    if (paymentStatus === "Success") {
      const req = {
        razorpay_order_id: stepOneDeets.id,
        razorpay_payment_id: paymentDetails.razorpay_payment_id,
        razorpay_signature: paymentDetails.razorpay_signature,
      };

      PaymentService.verifySignature(req)
        .then((response) => {
          if (response.data) {
            setOpenModal(true);

            // window.location.reload();
          }
        })
        .catch((e) => console.log(e));
    } else if (paymentStatus === "Failure") {
      setOpenModal(true);
    }
  };

  const downloadReceiptAsPDF = () => {
    const input = document.getElementsByClassName("receipt-container")[0];
    html2canvas(input, { scale: 2, useCORS: true, logging: true })
      .then((canvas) => {
        const imgData = canvas.toDataURL("image/png");
        const pdf = new jsPDF("p", "mm", "a4");
        const pageWidth = pdf.internal.pageSize.getWidth();
        const pageHeight = pdf.internal.pageSize.getHeight();
        const margin = 10; // margin in mm
        const maxWidth = pageWidth - margin * 2;
        const imgWidth = maxWidth;
        const imgHeight = (canvas.height * imgWidth) / canvas.width;

        pdf.addImage(
          imgData,
          "PNG",
          margin,
          margin,
          pageWidth - margin * 2,
          imgHeight - margin * 2
        );
        pdf.save("Receipt.pdf");
      })
      .catch((error) => {
        console.error("Error generating PDF: ", error);
      });
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    localStorage.removeItem("aplntEml");
    localStorage.removeItem("userDeets");
    // window.location.reload();
    navigate("/");
  };

  return (
    <div className="">
      <div className="row m-0 align-items-center">
        <div className="col col-2 pe-0">
          <ProjectSidebar />
        </div>
        <div className="col col-10 p-0">
          <div className="projects-mainPanel">
            <div className="login-main-container tender-container">
              <svg
                className="login-svg1"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 414.35 414.322"
              >
                <g
                  id="Group_16"
                  data-name="Group 16"
                  transform="translate(-5995.863 -1507.947)"
                  opacity="0.18"
                >
                  <path
                    id="Path_100"
                    data-name="Path 100"
                    d="M518.286,856.444a5.054,5.054,0,1,0,0,10.082c28.1,0,40.651-23.2,53.932-47.775,17.287-31.994,36.86-68.289,94.825-72.913a14.975,14.975,0,0,0,12.636-20.352l-25.81-68.853A180.134,180.134,0,0,0,703.634,622.7a5.109,5.109,0,0,0,1.4-4.382,5.027,5.027,0,0,0-2.688-3.71l-80.791-40.328a3.711,3.711,0,0,0-1.264-.43L519.308,553.634a5.215,5.215,0,0,0-6.076,3.844,5.055,5.055,0,0,0,3.952,5.942l98.239,19.626,25.353,67.617a70.651,70.651,0,0,1-21.508,3.737H518.286a5.055,5.055,0,1,0,0,10.082H619.268a80.354,80.354,0,0,0,25.165-4.355l25.81,68.827a5.081,5.081,0,0,1-4.033,6.748c-63.4,5.082-85.28,45.705-102.864,78.156C550.495,837.677,540.386,856.444,518.286,856.444Zm110.23-267.456,62.724,31.375a169.839,169.839,0,0,1-40.946,26.885Z"
                    transform="translate(5483 974.926)"
                    fill="#c3e3a8"
                  />
                  <path
                    id="Path_101"
                    data-name="Path 101"
                    d="M628.932,636.15a85.845,85.845,0,1,0,85.818,85.827A85.845,85.845,0,0,0,628.932,636.15Zm0,161.554a75.736,75.736,0,1,1,75.736-75.736A75.736,75.736,0,0,1,628.932,797.7Z"
                    transform="translate(5533.989 1114.429)"
                    fill="#c3e3a8"
                  />
                  <path
                    id="Path_102"
                    data-name="Path 102"
                    d="M616.251,643.66A65.654,65.654,0,1,0,681.878,709.3,65.654,65.654,0,0,0,616.251,643.66Zm0,121.172A55.545,55.545,0,1,1,671.769,709.3,55.545,55.545,0,0,1,616.251,764.832Z"
                    transform="translate(5546.67 1127.11)"
                    fill="#c3e3a8"
                  />
                  <path
                    id="Path_103"
                    data-name="Path 103"
                    d="M624.731,682.938l11.077-11.077a5.057,5.057,0,1,0-7.151-7.151L617.58,675.787a25.648,25.648,0,0,0-8.872-3.683V656.456a5.055,5.055,0,1,0-10.082,0V672.1a25.652,25.652,0,0,0-8.872,3.683L578.677,664.71a5.054,5.054,0,0,0-7.125,7.151l11.077,11.077a25.192,25.192,0,0,0-3.71,8.872H563.406a5.054,5.054,0,1,0,0,10.082h15.647a25.189,25.189,0,0,0,3.71,8.872l-11.292,11.077a5.038,5.038,0,1,0,7.125,7.125l11.077-11.077a24.653,24.653,0,0,0,8.872,3.683v15.674a5.054,5.054,0,1,0,10.082,0V721.573a24.652,24.652,0,0,0,8.872-3.683l11.077,11.077a5.054,5.054,0,0,0,7.151-7.125L624.65,710.765a25.646,25.646,0,0,0,3.683-8.872h15.728a5.054,5.054,0,1,0,0-10.082H628.414A25.654,25.654,0,0,0,624.731,682.938Zm-21,29.063a15.163,15.163,0,1,1,15.136-15.163A15.164,15.164,0,0,1,603.734,712Z"
                    transform="translate(5559.188 1139.559)"
                    fill="#c3e3a8"
                  />
                  <path
                    id="Path_104"
                    data-name="Path 104"
                    d="M581.174,608.681a5.055,5.055,0,1,0,0-10.082H540.846a5.054,5.054,0,1,0,0,10.082Z"
                    transform="translate(5521.093 1050.999)"
                    fill="#c3e3a8"
                  />
                  <path
                    id="Path_105"
                    data-name="Path 105"
                    d="M609.616,616.192a14.463,14.463,0,0,1,7.5,2.124,5.054,5.054,0,1,0,5.162-8.684,24.573,24.573,0,0,0-12.663-3.522,25.245,25.245,0,1,0,0,50.491,24.842,24.842,0,0,0,12.663-3.522,5.054,5.054,0,1,0-5.162-8.684,14.438,14.438,0,0,1-7.5,2.1,15.163,15.163,0,1,1,0-30.3Z"
                    transform="translate(5603.743 1063.705)"
                    fill="#c3e3a8"
                  />
                  <path
                    id="Path_106"
                    data-name="Path 106"
                    d="M518.252,899.6H558.58a25.272,25.272,0,0,0,25.245-25.245,95.947,95.947,0,1,1,191.894,0,25.245,25.245,0,1,0,50.477,0V858.706a25.273,25.273,0,0,0,20.191-24.735V793.509A25.272,25.272,0,0,0,826.2,768.774V753.181a50.166,50.166,0,0,0-2.957-15.109h38.312a45.517,45.517,0,0,0,45.436-45.463V616.872h15.136a5.054,5.054,0,0,0,5.054-5.028V571.517a5.055,5.055,0,0,0-5.055-5.055V551.326a5.054,5.054,0,1,0-10.082,0v15.136H891.824V551.326a5.054,5.054,0,1,0-10.082,0v15.136a5.054,5.054,0,0,0-5.054,5.054v40.328a5.055,5.055,0,0,0,5.054,5.028h15.136v75.736a35.381,35.381,0,0,1-35.327,35.354h-42.1c-20.03-46.35-78.344-118.86-92.4-136.013l16.938-16.965a4.974,4.974,0,0,0,1.183-5.377,5.081,5.081,0,0,0-4.3-3.334l-222.154-20.11a5.108,5.108,0,0,0-5.377,4.571,5.054,5.054,0,0,0,4.571,5.377l211.427,19.223-12.582,12.582a5.082,5.082,0,0,0-.3,6.8c22.234,26.7,72.913,91.948,92.163,133.109h-78.29a5.054,5.054,0,0,0,0,10.109h82.431a45.976,45.976,0,0,1,3.388,15.11V768.21H780.815a5.054,5.054,0,0,0-5.054,5.027v34.145a5,5,0,0,0,.86,2.689,108.561,108.561,0,0,1,17.583,44.6,5.028,5.028,0,0,0,4.974,4.275h16.965v15.136a15.163,15.163,0,1,1-30.3,0,106.029,106.029,0,1,0-212.058,0,15.19,15.19,0,0,1-15.15,15.163H518.305a5.054,5.054,0,1,0,0,10.082ZM886.9,606.79v-30.3h30.273v30.3ZM803.56,849.108a118.1,118.1,0,0,0-17.61-43.017V778.426H821.3a15.19,15.19,0,0,1,15.056,15.083v40.328A15.163,15.163,0,0,1,821.2,848.974Z"
                    transform="translate(5483.034 962.043)"
                    fill="#c3e3a8"
                  />
                </g>
              </svg>
              <svg
                className="login-svg2"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 556.111 556.111"
              >
                <g
                  id="Group_15"
                  data-name="Group 15"
                  transform="translate(0)"
                  opacity="0.37"
                >
                  <path
                    id="Path_76"
                    data-name="Path 76"
                    d="M470.728,444.193a33.908,33.908,0,1,1,67.817,0,33.114,33.114,0,0,1-11.267,25.025,6.789,6.789,0,0,0-.65,9.569,6.861,6.861,0,0,0,9.606.65,46.692,46.692,0,0,0,15.853-35.245,47.486,47.486,0,0,0-94.936,0,46.619,46.619,0,0,0,15.889,35.245,6.789,6.789,0,0,0,8.919-10.219A33.078,33.078,0,0,1,470.728,444.193Z"
                    transform="translate(-321.517 -44.081)"
                    fill="#118e1d"
                    opacity="0.18"
                  />
                  <path
                    id="Path_77"
                    data-name="Path 77"
                    d="M471.532,361.946H487.71l-22.245-44.417a6.789,6.789,0,1,1,12.133-6.067l27.12,54.167a6.789,6.789,0,0,1-6.067,9.822H482.546l22.208,44.417a6.789,6.789,0,1,1-12.133,6.067L465.5,371.768a6.789,6.789,0,0,1,6.067-9.822Z"
                    transform="translate(-301.99 -280.551)"
                    fill="#118e1d"
                    opacity="0.18"
                  />
                  <path
                    id="Path_78"
                    data-name="Path 78"
                    d="M672.175,469.849h-291.6V449.519a6.789,6.789,0,0,0-13.578,0v27.12a6.789,6.789,0,0,0,6.789,6.789H672.175a6.789,6.789,0,1,0,0-13.578Z"
                    transform="translate(-122.853 72.684)"
                    fill="#118e1d"
                    opacity="0.18"
                  />
                  <path
                    id="Path_79"
                    data-name="Path 79"
                    d="M693.757,530.57H571.666V849.323a6.789,6.789,0,0,1-6.753,6.789H456.4a6.789,6.789,0,1,1,0-13.578H557.943V523.889a6.789,6.789,0,0,1,6.789-6.789h20.33V475.645a33.945,33.945,0,0,1-27.119-33.222V333.908A33.945,33.945,0,0,1,591.852,300H673.5a33.945,33.945,0,0,1,33.909,33.908V442.422a33.944,33.944,0,0,1-27.155,33.222v41.383h20.367a6.789,6.789,0,0,1,6.789,6.789V767.964a6.789,6.789,0,0,1-13.578,0ZM666.638,476.4H598.821v40.625h67.817Zm6.861-13.65a20.367,20.367,0,0,0,20.331-20.331V333.908A20.367,20.367,0,0,0,673.5,313.578H592.1a20.367,20.367,0,0,0-20.367,20.331V442.422A20.367,20.367,0,0,0,592.1,462.753Z"
                    transform="translate(-449.61 -300)"
                    fill="#118e1d"
                    opacity="0.18"
                  />
                  <path
                    id="Path_80"
                    data-name="Path 80"
                    d="M545.313,367.61a6.789,6.789,0,0,1,6.753,6.789v54.167a6.789,6.789,0,0,1-6.753,6.789H463.919a6.789,6.789,0,0,1-6.789-6.789V374.4a6.789,6.789,0,0,1,6.789-6.789Zm-6.789,13.578H470.708v40.661h67.745Z"
                    transform="translate(-321.424 -123.463)"
                    fill="#118e1d"
                    opacity="0.18"
                  />
                  <path
                    id="Path_81"
                    data-name="Path 81"
                    d="M692.614,395.732v40.661h47.378a6.789,6.789,0,0,1,0,13.578H692.614v13.578a6.789,6.789,0,0,1-6.861,6.68H604.358a6.9,6.9,0,0,1-4.082-1.336l-27.119-20.33a6.824,6.824,0,0,1-2.708-5.453V422.779H522.892a20.366,20.366,0,0,0-20.33,20.33v54.167a20.367,20.367,0,0,0,20.331,20.331H685.753a33.944,33.944,0,0,1,33.908,33.908v54.167a33.944,33.944,0,0,1-33.908,34.269H373.789A6.789,6.789,0,0,1,367,633.162V538.118a6.789,6.789,0,1,1,13.578,0V626.3H685.753a20.367,20.367,0,0,0,20.331-20.331V551.8a20.367,20.367,0,0,0-20.331-20.331H522.892a33.944,33.944,0,0,1-33.908-33.908V443.4a33.944,33.944,0,0,1,33.908-33.908H570.45V389.159a6.825,6.825,0,0,1,2.708-5.453l27.12-20.331a6.9,6.9,0,0,1,4.081-1.336h81.394a6.789,6.789,0,0,1,6.789,6.753v13.578h47.45a6.789,6.789,0,1,1,0,13.578Zm-13.578-20.367H606.814l-22.606,16.972v47.45l22.606,16.972h72.222Z"
                    transform="translate(-190.669 -138.007)"
                    fill="#118e1d"
                    opacity="0.18"
                  />
                </g>
              </svg>
              <div className="login-container gap-4">
                <span className="login-heading" style={{ fontSize: "30px" }}>
                  Project Payments
                </span>
                <div className="login-box">
                  <div className="login-form-container gap-0">
                    {isVerified ? (
                      <form onSubmit={handleGetOrderId}>
                        <div className="row">
                          <div className="col col-12 mb-4">
                            <div className="input-class">
                              <label>Email*</label>
                              <div className="input-group">
                                <input
                                  type="email"
                                  className="form-control"
                                  placeholder="Enter valid Email ID"
                                  id="validationDefaultUsername"
                                  aria-describedby="inputGroupPrepend2"
                                  required
                                  value={applicantEmail}
                                  name="email"
                                  readOnly
                                />

                                <span className="right-tick-verify">
                                  <FaCheck
                                    fill="green"
                                    height={"20px"}
                                    width={"24px"}
                                  />
                                </span>
                              </div>
                            </div>
                          </div>
                          <div className="col col-12 mb-4">
                            <div className="input-class">
                              <label>Name*</label>
                              <input
                                type="text"
                                name="name"
                                className="form-control"
                                placeholder="Enter Your Name"
                                value={details.name}
                                onChange={handleChange}
                                required
                              />
                            </div>
                          </div>
                          <div className="col col-12 mb-4">
                            <div className="input-class">
                              <label>Phone Number*</label>
                              <input
                                type="text"
                                className="form-control"
                                maxLength={10}
                                placeholder="Enter Your Phone Number"
                                name="mobileNum"
                                value={details.mobileNum}
                                onChange={handleChange}
                                required
                              />
                            </div>
                          </div>
                          <div className="col col-12 mb-4">
                            <div className="input-class">
                              <label>Company Name</label>
                              <input
                                type="text"
                                className="form-control"
                                name="companyName"
                                placeholder="Enter Company Name"
                                value={details.companyName}
                                onChange={handleChange}
                              />
                            </div>
                          </div>
                          <div className="col col-12 col-md-6 col-lg-6 mb-4">
                            <div className="input-class">
                              <label>Category*</label>

                              <select
                                class="form-select form-select-lg mb-3"
                                aria-label="Large select example"
                                onChange={handleChange}
                                value={details.category}
                                name="category"
                              >
                                <option selected disabled value="">
                                  SelectCat
                                </option>
                                <option value="Document Charges">
                                  Document Charges
                                </option>
                                <option value="Processing Fees">
                                  Processing Fees
                                </option>
                                <option value="Earnest Money Deposit">
                                  Earnest Money Deposit
                                </option>
                                <option value="Other Advances">
                                  Other Advances
                                </option>
                              </select>
                              <span className="mandatory">
                                *Mandatory fields
                              </span>
                            </div>
                          </div>
                          <div className="col col-12 col-md-6 col-lg-6 mb-4">
                            <div className="input-class">
                              <label>Amount*</label>
                              <input
                                type="text"
                                className="form-control"
                                value={finalAmt}
                                readOnly={!isCustomCharge}
                                placeholder={
                                  isCustomCharge ? "Enter Amount here" : ""
                                }
                                onChange={
                                  isCustomCharge ? handleCustomCharges : ""
                                }
                              />
                            </div>
                          </div>
                          <div className="text-center">
                            <button
                              id="rzp-button1"
                              className="login-btn"
                              type="submit"
                            >
                              Submit & Pay
                            </button>
                          </div>
                        </div>
                      </form>
                    ) : (
                      <form onSubmit={handleGetOtp}>
                        <div className="row email-form">
                          <div className="col col-12 mb-4">
                            <div className="input-class">
                              <label>Email*</label>
                              <div className="input-group">
                                <input
                                  type="email"
                                  className="form-control"
                                  placeholder="Enter valid Email ID"
                                  id="validationDefaultUsername"
                                  aria-describedby="inputGroupPrepend2"
                                  required
                                  value={details.email}
                                  name="email"
                                  onChange={handleChange}
                                  readOnly={isVerified}
                                />

                                <div className="input-group-append">
                                  <button
                                    className="btn get-app-ot-st"
                                    type="submit"
                                    style={{ width: "140px" }}
                                  >
                                    Verify
                                  </button>
                                </div>
                              </div>
                              <span className="mandatory">
                                *An OTP will be sent to this mail id
                              </span>
                            </div>
                          </div>
                        </div>
                      </form>
                    )}
                  </div>
                </div>
              </div>

              <div id="otp-modal">
                <Modal
                  size="md"
                  centered
                  show={openOtpModal}
                  aria-labelledby="example-modal-sizes-title-lg"
                >
                  <Modal.Header style={{ borderBottom: "none" }}>
                    <Modal.Title>Enter OTP</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <div
                      className="d-flex flex-column justify-content-center align-items-center gap-4 mb-3 tender-container w-100"
                      style={{ minHeight: "auto" }}
                    >
                      <div className="text-center" style={{ width: "80%" }}>
                        <div className="input-group login-form-input w-100 mt-0 mb-5">
                          <input
                            style={{ borderRadius: "4px" }}
                            width={"100%"}
                            type="text"
                            maxLength={6}
                            className="form-control"
                            placeholder="Enter OTP received"
                            id="validationDefaultUsername"
                            aria-describedby="inputGroupPrepend2"
                            required
                            name="otp"
                            value={otp}
                            onChange={handleOtpChange}
                          />
                          <svg
                            style={{ top: "9px" }}
                            xmlns="http://www.w3.org/2000/svg"
                            xmlnsXlink="http://www.w3.org/1999/xlink"
                            version="1.1"
                            id="Capa_1"
                            x="0px"
                            y="0px"
                            viewBox="0 0 512 512"
                            //   style="enable-background:new 0 0 512 512;"
                            xmlSpace="preserve"
                            width="20"
                            height="20"
                          >
                            <g>
                              <path d="M405.333,179.712v-30.379C405.333,66.859,338.475,0,256,0S106.667,66.859,106.667,149.333v30.379   c-38.826,16.945-63.944,55.259-64,97.621v128C42.737,464.214,90.452,511.93,149.333,512h213.333   c58.881-0.07,106.596-47.786,106.667-106.667v-128C469.278,234.971,444.159,196.657,405.333,179.712z M277.333,362.667   c0,11.782-9.551,21.333-21.333,21.333c-11.782,0-21.333-9.551-21.333-21.333V320c0-11.782,9.551-21.333,21.333-21.333   c11.782,0,21.333,9.551,21.333,21.333V362.667z M362.667,170.667H149.333v-21.333c0-58.91,47.756-106.667,106.667-106.667   s106.667,47.756,106.667,106.667V170.667z" />
                            </g>
                          </svg>
                        </div>
                        <button
                          className="login-btn"
                          type="submit"
                          style={{ width: "130px" }}
                          onClick={submitOtp}
                        >
                          Submit
                        </button>
                      </div>
                    </div>
                  </Modal.Body>
                </Modal>
              </div>
              <div className="tender-receipt-modal">
                <Modal
                  size="lg"
                  centered
                  show={openModal}
                  aria-labelledby="example-modal-sizes-title-lg"
                >
                  <Modal.Header style={{ borderBottom: "none" }}>
                    <Modal.Title>Transaction Details</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <div className="d-flex flex-column justify-content-start align-items-center p-4  tender-modal w-100">
                      {paymentStatus === "Success" && (
                        <>
                          <div className="mb-3 payment-receipt-download-btns">
                            <button
                              className="download-btn"
                              type="button"
                              onClick={downloadReceiptAsPDF}
                            >
                              Download
                            </button>
                          </div>
                          <div className="receipt-container">
                            <div className="d-flex justify-content-between align-items-center">
                              <img src={icon} alt="img" />
                              <h3>TENDER PAYMENT RECEIPT</h3>
                            </div>
                            <div className="row mt-5">
                              <div className="col col-6">
                                <div>
                                  <div className="fw500">Issued By :</div>
                                  <div>{details.name}</div>
                                  <div>{details.email}</div>
                                  <div>{details.mobileNum}</div>
                                </div>
                              </div>
                              <div className="col col-6">
                                <div className="ps-4">
                                  <div className="fw500">Transaction Date:</div>
                                  <div>{currentDate}</div>
                                  <div className="fw500">Transaction ID:</div>
                                  <div>
                                    {paymentDetails.razorpay_payment_id}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="mt-5">
                              <Table responsive>
                                <thead>
                                  <tr>
                                    <th>Sr. No</th>
                                    <th>Description</th>
                                    <th className="text-end">Price</th>
                                    <th className="text-end">SubTotal</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr style={{ height: "150px" }}>
                                    <td>1.</td>
                                    <td>{details.category}</td>
                                    <td className="text-end">Rs. {charges}</td>
                                    <td className="text-end">Rs. {charges}</td>
                                  </tr>
                                  <tr>
                                    <td colSpan={3} className="text-end">
                                      Total Amount
                                    </td>
                                    <td className="fw500 text-end">
                                      Rs. {charges}
                                    </td>
                                  </tr>
                                </tbody>
                              </Table>
                            </div>
                            <div className="fw500">
                              Transaction Status - Payment was Successful
                            </div>
                          </div>
                          <div className="mt-3 payment-receipt-download-btns">
                            <button
                              className="close-btn"
                              type="button"
                              onClick={handleCloseModal}
                            >
                              Back to Home
                            </button>
                            <button
                              className="download-btn"
                              type="button"
                              onClick={downloadReceiptAsPDF}
                            >
                              Download
                            </button>
                          </div>
                        </>
                      )}
                      {paymentStatus === "Failure" && (
                        <div className="text-start" style={{ width: "80%" }}>
                          <div>
                            <h3>Transaction Failed!</h3>
                          </div>
                          <div className="mt-3 payment-receipt-download-btns">
                            <button
                              className="close-btn"
                              type="button"
                              onClick={handleCloseModal}
                            >
                              Back to Home
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                  </Modal.Body>
                </Modal>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TenderPayment;
